export enum PaymentState {
  PENDING = 'PENDING',
  PAID = 'PAID',
  REFUNDED = 'REFUNDED',
  AUTH_FAIL = 'AUTHORIZATION_FAILED',
  CAPTURE_FAIL = 'CAPTURE_FAILED',
  CANCELED = 'CANCELED'
}
